import { Component, Input } from '@angular/core';
import { CSSProperties, Image } from '../../../models';

/**
 * This component is responsible to create a image tag with
 * visibility configuration and custom styling attributes.
 */
@Component({
  selector: 'idp-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent {
  @Input() content: Image = {} as Image;
  @Input() styles: CSSProperties = {} as CSSProperties;
}
